/**
 * A curated list of IANA timezones for the settings dropdown. Not exhaustive —
 * covers the regions DeutschApp users are most likely in (Europe + Americas).
 * Power users can edit `user_settings.timezone` directly via export/import or
 * a future free-form input if needed.
 */
export const COMMON_TIMEZONES = [
  'Europe/Berlin',
  'Europe/Lisbon',
  'Europe/Madrid',
  'Europe/London',
  'Europe/Paris',
  'Europe/Rome',
  'Europe/Amsterdam',
  'Europe/Vienna',
  'Europe/Zurich',
  'America/Sao_Paulo',
  'America/Buenos_Aires',
  'America/Mexico_City',
  'America/Bogota',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Toronto',
  'UTC',
];
